export default __webpack_public_path__ + "static/media/inoodle.423aaffb.jpeg";